import React, { useEffect, useState } from 'react';
import { Table, Tag, Card } from 'antd';
import { formatDateTime } from '../../utils/format';
import { getChains } from '../../services/chains';
import './style.css';

const Chains = () => {
  const [chains, setChains] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchChains = async () => {
    setLoading(true);
    try {
      const response = await getChains();
      setChains(response.data);
    } catch (error) {
      console.error('Failed to fetch chains:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChains();
  }, []);

  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '状态',
      dataIndex: 'is_enabled',
      key: 'is_enabled',
      render: (enabled) => (
        <Tag color={enabled ? 'green' : 'red'}>
          {enabled ? '启用' : '禁用'}
        </Tag>
      ),
    },
    {
      title: '适配器',
      dataIndex: 'adapter',
      key: 'adapter',
    },
    {
      title: '所需确认数',
      dataIndex: 'required_confirmations',
      key: 'required_confirmations',
    },
    {
      title: '最小高度',
      dataIndex: 'minimum_height',
      key: 'minimum_height',
    },
    {
      title: '创建时间',
      dataIndex: 'inserted_at',
      key: 'inserted_at',
      render: (date) => formatDateTime(date),
    },
    {
      title: '更新时间',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (date) => formatDateTime(date),
    },
  ];

  return (
    <Card title="Chains" className="chains-card">
      <Table
        loading={loading}
        dataSource={chains}
        columns={columns}
        rowKey="id"
        pagination={false}
      />
    </Card>
  );
};

export default Chains;
